<form #form="ngForm" class="motivo-perda-venda-plm-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Ciclo de Vida do Produto (PLM)
            </h6>
            <p class="form-text text-muted">
                Selecione em quais decisões de gate este motivo deve ser exibido e ficar disponível para ser selecionado
            </p>
        </div>
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.avancoComRessalvasPLM" name="avancoComRessalvasPLM" id="avancoComRessalvasPLM">
                    <label class="custom-control-label" for="avancoComRessalvasPLM">Avanço com Ressalvas</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo no avanço de produtos à Maturidade com plano de correção</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.permanenciaPLM" name="permanenciaPLM" id="permanenciaPLM">
                    <label class="custom-control-label" for="permanenciaPLM">Permanência na Fase</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo na permanência de produtos na fase atual por um novo prazo</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.revitalizacaoPLM" name="revitalizacaoPLM" id="revitalizacaoPLM">
                    <label class="custom-control-label" for="revitalizacaoPLM">Revitalização</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo na revitalização de produtos</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.reposicionamentoPLM" name="reposicionamentoPLM" id="reposicionamentoPLM">
                    <label class="custom-control-label" for="reposicionamentoPLM">Reposicionamento</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo no reposicionamento de produtos</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.encerramentoPLM" name="encerramentoPLM" id="encerramentoPLM">
                    <label class="custom-control-label" for="encerramentoPLM">Encerramento</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se deseja exibir este motivo no encerramento de produtos</p>
            </li>
        </ul>
    </div>
</form>
